import { render, staticRenderFns } from "./TextEdit.vue?vue&type=template&id=974f079a"
import script from "./TextEdit.vue?vue&type=script&lang=js"
export * from "./TextEdit.vue?vue&type=script&lang=js"
import style0 from "./TextEdit.vue?vue&type=style&index=0&id=974f079a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports